$ = require 'jquery'
ActionView = require 'app/scripts/views/action/action-view'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CardAttachLinksView = require 'app/scripts/views/card/attach-links-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
{ getKey, isForceSubmitEvent, Key } = require '@trello/keybindings'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
{ TrelloStorage } = require '@trello/storage'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
f = require 'effing'
linksFromMarkdown = require 'app/scripts/lib/util/text/links-from-markdown'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
LengthCheckingMixin = require 'app/scripts/views/internal/disable-submit-if-length-too-long'

module.exports = mixin AutoInsertionView, CompleterUtil, LengthCheckingMixin, class CommentActionView extends ActionView
  events: Util.extendEvents
    'click .js-confirm-delete-action': 'confirmDeleteAction'
    'click .js-edit-action': 'editAction'
    'click .js-discard-comment-edits': 'cancelEdit'
    'click .js-save-edit': 'saveEdit'
    'keyup .js-text': 'keyAutoMention'
    'keydown .js-text': 'keydownJsText'
    'input .js-text': 'checkLength'
    'mutated .js-text': 'mutatedEvent'

    'click .js-comment-add-attachment': 'commentAddAttachment'
    'click .js-comment-mention-member': 'commentMentionMember'
    'click .js-comment-add-emoji': 'commentAddEmoji'
    'click .js-comment-add-card': 'commentAddCard'
    'click .js-attach-link': 'attachLink'

  initialize: ->
    super
    $(window).on "beforeunload.CommentActionView-#{@model.cid}", f(@, 'saveDraft')

  remove: ->
    @saveDraft()
    $(window).off ".CommentActionView-#{@model.cid}"
    super
    return

  mutatedEvent: (e) ->
    @checkLength(e)
    @getTextInput().trigger('autosize.resize')
    return

  potentialAttachments: ->
    card = @model.getCard()
    _.filter linksFromMarkdown(@model.get('data').text, TFM.comments), ({ url }) ->
      # Don't include URLs that are not allowed by the enterprise
      if card.attachmentUrlRestricted(url)
        return false

      # Don't include things that have already been attached
      !card.attachmentList.any (attachment) ->
        attachment.get('url') == url

  getContext: ->
    data = super
    card = @model.getCard()
    # It's possible that comment is for a card that isn't currently cached, in
    # which case we can't attach a link to it
    data.canAttachLink = card? && card.editable() && @potentialAttachments().length > 0
    data

  confirmDeleteAction: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete comment',
      elem: $(e.target).closest('.js-confirm-delete-action')[0]
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        track("Card", "Delete Comment")
        @model.destroy()

    return

  getTextInput: ->
    @$('.js-text')

  getMentionTarget: ->
    @$('.js-comment-mention-member:visible')[0]

  getEmojiTarget: ->
    @$('.js-comment-add-emoji:visible')[0]

  editAction: (e) ->
    Util.stop(e)
    return if @$el.hasClass('is-editing')
    @$el.addClass('is-editing')
    @$('textarea').focus().select()
    @openEditView()

  openEditView: ->
    @$('.js-text').attr('placeholder', '').autosize(append: false)
    return

  keydownJsText: (e) ->
    if isForceSubmitEvent(e)
      @saveEdit(e)
    else if getKey(e) == Key.Escape
      Util.stop(e)
      @cancelEdit()
    else
      @checkInsert(e)

  saveEdit: (e) ->
    if !(e.type != 'keypress' ||
          # If they pressed ctrl+enter, then that's always a submit
          (isForceSubmitEvent(e)) ||
          # If they pressed enter, and they aren't on a multi-line textarea, that's also a submit
          (getKey(e) == Key.Enter && (!$(e.target).is("textarea") || $(e.currentTarget).hasClass('single-line'))))
      return

    Util.stop(e)
    newValue = @$('.js-text').val()

    @$('.js-spinner').show()
    @$('.js-hide-on-sending').hide()

    @$('.current-comment').text(newValue)
    Layout.cancelEdit(@$el)
    @discardDraft()

    # So that we don't have to wait for the roundtrip to display the
    # new text, which would be very scary for users.
    @model.get('display').entities.comment.text = newValue
    @model.update('text', newValue)

    @$('.js-text').trigger('autosize.destroy')

    PopOver.hide()
    track("Card", "Edit Comment")

    return

  showError: (e) ->
    return

  cancelEdit: ->
    prevComment = @model.get('data').text
    @$('.js-text').val(prevComment)
    Layout.cancelEdit(@$el)
    @discardDraft()
    @$('.js-text').trigger('autosize.destroy')
    return

  getCard: ->
    @model.getCard()

  attachLink: (e) ->
    Util.stop(e)

    track("Card", "Open Attach Links View")
    links = @potentialAttachments()
    PopOver.toggle
      elem: $(e.currentTarget)
      view: new CardAttachLinksView({ model: @getCard(), @modelCache, links })

  render: ->
    super
    @recallDraft()

    @

  _draftKey: -> "draft_#{@model.id}_edit"

  recallDraft: ->
    draftText = TrelloStorage.get @_draftKey()
    if draftText
      @getTextInput().val(draftText)
      @$el.find('.edits-warning').show()

  saveDraft: ->
    if @$el.hasClass('is-editing')
      text = @getTextInput().val()

      if text && text != @model.get('data').text
        TrelloStorage.set @_draftKey(), text
        @$el.find('.edits-warning').show()
      else
        @discardDraft()

    return

  discardDraft: ->
    TrelloStorage.unset @_draftKey()
    @$el.find('.edits-warning').hide()
